import { Component } from '@angular/core';

@Component({
  selector: 'app-empty',
  standalone: false,
  template: '',
})
export class EmptyComponent {}
